export const GOOGLE_API_URL = 'https://apis.google.com/js/api.js'
export const DOM_ID = '___GOOGLE_LOGIN___'
